import { Injectable } from '@angular/core';
import jwt_decode from 'jwt-decode';
import { LocalStorage_RefreshToken, LocalStorage_AuthToken, LocalStorage_ExpiresAt, LicenseManagerClientId } from '../constants/constants';

@Injectable({
    providedIn: 'root',
})
export class AccessTokenService {
    constructor() {

    }

    public getToken(): string {
        return localStorage.getItem(LocalStorage_AuthToken);
    }

    public getRefresh(): string {
        return localStorage.getItem(LocalStorage_RefreshToken);
    }

    public clearToken(): void {
        console.log('Clearing access token');

        localStorage.removeItem(LocalStorage_AuthToken);
        localStorage.removeItem(LocalStorage_RefreshToken);
        localStorage.removeItem(LocalStorage_ExpiresAt);
    }

    public isTokenExpired(): boolean {
        const token = this.getToken();
        if (!token) {
            return true;
        }

        const date = this.getDataFromToken(token);
        if (!date) {
            return true;
        }

        return date < Date.now();
    }

    public hasRefreshToken(): boolean {
        var refreshToken = this.getRefresh();

        return refreshToken !== "" && refreshToken !== null && refreshToken !== undefined;
    }


    private getDataFromToken(token: string): number {
        try {
            const decoded = jwt_decode(token);
            return decoded['exp'] * 1000;
        }
        catch {
            return 0;
        }
    }
}